// Sección "Cómo elevamos el nivel": cambia la pestaña activa del toggle superior.

class RaisingBar {
  constructor(root) {
    this.root = root;

    // Pestañas superiores: solo marcan la activa (mismo contenido por ahora)
    this.tabs = [...root.querySelectorAll('[data-tab-index]')];
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab));
    });
  }

  activateTab(tab) {
    this.tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
  }
}

function initRaisingBar() {
  document.querySelectorAll('[data-raising-bar]').forEach((root) => {
    if (!root.__raisingBarInit) {
      root.__raisingBarInit = true;
      new RaisingBar(root);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRaisingBar);
} else {
  initRaisingBar();
}

// Soporte para el editor de temas de Shopify (re-render de secciones)
document.addEventListener('shopify:section:load', initRaisingBar);
